import { render, staticRenderFns } from "./MenuDetailsPopup.vue?vue&type=template&id=1ea4dcee&scoped=true&"
import script from "./MenuDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./MenuDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetailsPopup.vue?vue&type=style&index=0&id=1ea4dcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4dcee",
  null
  
)

export default component.exports